<template>

  <div class="stock-slips">
     <KTCodePreview v-bind:title="pageTitle"
      > <template v-slot:toolbar
        >
        <div class="row">

          <div>
             <b-dropdown
              size="sm"
              id="dropdown-1"
              right
              > <template slot="button-content"
                > <i
                  style="font-size: 1rem"
                  class="fas fa-cog"
                ></i
                > <span class="font-weight-bolder">Thao tác</span> </template
              > <b-dropdown-item @click="reportClick"
                > <span
                  > <i
                    style="font-size: 1rem"
                    class="far fa-file-excel"
                  ></i
                  > &nbsp; Xuất Excel</span
                > </b-dropdown-item
              > </b-dropdown
            >
          </div>

          <div
            v-if="!isAutoListPage && checkPermission(listPermission, 'STOCK_IMPORT_INSERT')"
            class="ml-3"
          >
             <router-link to="/inventory-receipt/add-inventory-receipt"
              > <b-button
                v-bind:style="btnCreate"
                variant="primary"
                size="sm"
                class="font-weight-bolder"
                > <i
                  style="font-size: 1rem"
                  class="flaticon2-add-1"
                ></i
                >Thêm mới </b-button
              > </router-link
            >
          </div>

        </div>
         </template
      > <template v-slot:preview
        > <!-- Header session --> <b-row class="mb-5"
          > <b-col
            >
            <div class="d-flex justify-content-center align-items-center">
               <date-picker
                placeholder="Từ ngày"
                class="form-control-sm"
                :config="dpConfigs.start"
                v-model="dpForm.startDate"
              ></date-picker
              > <span class="ml-1 mr"></span> <date-picker
                placeholder="Đến ngày"
                class="form-control-sm"
                :config="dpConfigs.end"
                v-model="dpForm.endDate"
              ></date-picker
              >
            </div>
             </b-col
          > <b-col
            > <BDropdownCustom
              v-model="valueStore"
              :options="filterdOptionsStore"
              :placeholder="'cửa hàng'"
              :matchKey="['name']"
              :searchable="true"
            /> </b-col
          > <b-col
            > <Autosuggest
              :model="searchProduct"
              :suggestions="filteredOptionsProduct"
              placeholder="mã, tên, mã vạch sản phẩm"
              :limit="10"
              @select="onSelectedProduct"
              @change="onInputChangeProduct"
              suggestionName="productName"
            /> </b-col
          > <b-col
            > <treeselect
              v-model="valueProviders"
              :multiple="true"
              :async="true"
              :load-options="loadProviderOptions"
              placeholder="Tìm NCC..."
              noResultsText="Không tìm thấy kết quả"
              loadingText="Đang tìm kiếm..."
              searchPromptText="Nhập để tìm kiếm..."
              :clearable="true"
              :cache-options="false"
              valueFormat="object"
            /> </b-col
          > <b-col
            > <b-form-select
              class="select-style"
              size="sm"
              v-model="selectedCompany"
              :options="listCompany"
              value-field="id"
              text-field="name"
              v-on:change="onChangeCompany"
              > <template v-slot:first
                > <b-form-select-option
                  :value="null"
                  disabled
                  >-- Doanh nghiệp --</b-form-select-option
                > </template
              > </b-form-select
            > </b-col
          > </b-row
        > <b-row class="mb-5"
          > <b-col
            > <b-form-input
              v-model="searchId"
              type="text"
              placeholder="Mã phiếu"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input
            > </b-col
          > <b-col
            > <b-form-input
              v-model="searchDescription"
              type="text"
              placeholder="Tìm kiếm theo nội dung"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input
            > </b-col
          > <b-col
            > <b-form-input
              v-model="searchPO"
              type="text"
              placeholder="Tìm kiếm theo mã PO"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input
            > </b-col
          > <b-col
            > <b-form-select
              class="select-style"
              size="sm"
              v-model="selectedType"
              :options="listType"
              value-field="id"
              text-field="name"
            ></b-form-select
            > </b-col
          > </b-row
        > <b-collapse id="inventory-receipt-advanced-search" class="mt-3 mb-2"
          > <b-row
            > <b-col
              > <b-form-input
                v-model="searchVatSerial"
                type="text"
                placeholder="Số ký hiệu"
                size="sm"
                v-on:keyup.enter="onFilter()"
              ></b-form-input
              > </b-col
            > <b-col
              > <b-form-input
                v-model="searchVatCode"
                type="text"
                placeholder="Số ĐH VAT"
                size="sm"
                v-on:keyup.enter="onFilter()"
              ></b-form-input
              > </b-col
            > <b-col
              >
              <div class="d-flex justify-content-center align-items-center">
                <date-picker
                  placeholder="Ngày xuất VAT từ"
                  class="form-control-sm"
                  :config="dpConfigs.start"
                  v-model="vatDateForm.fromDate"
                ></date-picker>
                <span class="ml-1 mr-1"></span>
                <date-picker
                  placeholder="Ngày xuất VAT đến"
                  class="form-control-sm"
                  :config="dpConfigs.end"
                  v-model="vatDateForm.toDate"
                ></date-picker>
              </div>
              </b-col
            ><b-col></b-col> </b-row
          > </b-collapse
        > <b-row class="mb-5 mt-3"
          > <b-col class="d-flex align-items-center" style="gap: 12px"
            > <b-button-group size="sm"
              > <b-button
                class="font-weight-bold"
                style="font-weight: 600; width: 70px"
                variant="primary"
                @click="onFilter"
                >Lọc</b-button
              > <b-button
                variant="primary"
                v-b-toggle.inventory-receipt-advanced-search
                class="togge-filter"
                aria-label="Mở rộng bộ lọc nâng cao"
                > <i class="fas fa-angle-down toggle-filter-icon"></i> </b-button
              > </b-button-group
            > <b-button variant="secondary" size="sm" @click="clearFilters"
              > <i class="fas fa-times mr-1"></i> Xóa bộ lọc </b-button
            > </b-col
          > </b-row
        > <!-- End of Header session --> <!-- Table session --> <b-table
          :items="stockSlips"
          :fields="fields"
          sort-by="count"
          class="table-bordered table-hover col-md-12 inventory-receipt-table"
          :busy="onLoading"
          > <template v-slot:table-busy
            > <vcl-table
              :speed="5"
              :animate="true"
              :columns="10"
            ></vcl-table
            > </template
          > <template v-slot:cell(count)="row"
            >
            <div style="text-align: center">
               <span
                v-text="row.item.count"
                class="text-right"
              ></span
              >
            </div>
             </template
          > <template v-slot:cell(code)="row"
            >
            <div class="inventory-receipt-code">
               <a
                v-if="!isAutoListPage"
                class="code-link font-weight-bold"
                :href="getLinkDoc(row.item)"
                target="_blank"
                > {{ row.item.code }} </a
              >
              <span
                v-else
                class="code-link font-weight-bold text-primary cursor-pointer"
                @click="openStockSlipItem(row.item)"
                > {{ row.item.code }} </span
              >
              <div
                v-if="row.item.purchaseOrderCode"
                class="po-code"
              >
                 <span class="po-label">Mã PO:</span> <span class="po-value">{{
                  row.item.purchaseOrderCode
                }}</span
                >
              </div>

              <div
                v-if="row.item.vatSerial"
                class="vat-serial"
              >
                <span class="vat-label text-muted">Số ký hiệu:</span>
                <span class="vat-value">{{ row.item.vatSerial }}</span>
              </div>
              <div
                v-if="row.item.vatCode"
                class="vat-serial"
              >
                <span class="vat-label text-muted">Số ĐH VAT:</span>
                <span class="vat-value">{{ row.item.vatCode }}</span>
              </div>

              <div
                v-if="row.item.vatDate"
                class="vat-serial"
              >
                <span class="vat-label text-muted">Ngày xuất VAT:</span>
                <span class="vat-value">{{ formatVatDate(row.item.vatDate) }}</span>
              </div>

            </div>
             </template
          > <template v-slot:cell(providerName)="row"
            > <ProviderInfo
              :providerName="row.item.providerName || ''"
              :providerCode="getProviderCode(row.item)"
              :providerTaxCode="getProviderTaxCode(row.item)"
            />
          <hr v-if="row.item.subProviderName || row.item.subProviderCode" />
            <div v-if="row.item.subProviderName || row.item.subProviderCode">
              <div v-if="row.item.subProviderName">
                <span v-b-tooltip.hover :title="'Tên NCC phụ'" v-text="row.item.subProviderName"></span>
              </div>
              <div v-if="row.item.subProviderCode">
                <small
                  class="text-warning"
                  v-b-tooltip.hover
                  :title="'Mã NCC phụ'"
                  v-text="row.item.subProviderCode"
                ></small>
              </div>
            </div>
            </template
          > <template v-slot:cell(sourceWarehouseId)="row"
            > <span
              v-text="row.item.sourceWarehouseId"
              class="font-weight-bolder"
            ></span
            > <br /> <span v-if="row.item.companyName">( {{ row.item.companyName }} )</span>
            </template
          > <template v-slot:cell(description)="row"
            >
            <div
              v-b-tooltip.hover
              :title="row.item.description || 'Không có nội dung'"
              class="inventory-receipt-description"
              @mouseover="hoverDescription = true"
              @mouseleave="hoverDescription = false"
            >
               <span
                v-text="row.item.description"
                class="inventory-receipt-description__text"
              ></span
              > <span
                v-if="!isAutoListPage"
                class="inventory-receipt-description__icon"
                @click.stop="handleShowNoteModel(row.item)"
                > <i
                  v-if="hoverDescription"
                  class="fas fa-edit"
                ></i
                > </span
              >
            </div>
             </template
          > <template v-slot:cell(countProduct)="row"
            >
            <div style="text-align: right">
               <span
                v-text="convertPrice(row.item.countProduct)"
                class="text-right"
              ></span
              >
            </div>
             </template
          > <template v-slot:cell(countQuantity)="row"
            >
            <div class="text-right">
               <span v-text="convertPrice(row.item.countQuantity)"></span>
            </div>
             </template
          > <template v-slot:cell(totalAmount)="row"
            >
            <div class="text-right font-weight-medium">
               <span v-text="formatMoney(row.item.totalAmount)"></span>
            </div>
             </template
          > <template v-slot:cell(createBy)="row"
            > <RowCreatedByDate
              :createdBy="row.item.createBy"
              :createdAt="row.item.createdAt"
            /> </template
          > <template v-slot:cell(actions)="row"
            >
            <div class="d-flex justify-content-center">
               <b-dropdown
                size="sm"
                id="dropdown-left"
                no-caret
                right
                > <template slot="button-content"
                  > <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i
                  > </template
                > <b-dropdown-item @click="printProductQRCode(row.item.id)"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="flaticon2-printer"
                    ></i
                    > &nbsp; In mã sản phẩm </span
                  > </b-dropdown-item
                > <b-dropdown-item @click="printItem(row.item)"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="flaticon2-printer"
                    ></i
                    > &nbsp; In phiếu </span
                  > </b-dropdown-item
                > <b-dropdown-item @click="exportDanhSachImeiExcel(row.item)"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="far fa-file-excel"
                    ></i
                    > &nbsp; Xuất Excel danh sách IMEI </span
                  > </b-dropdown-item
                > <b-dropdown-item @click="openStockSlipItem(row.item)"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      :class="isRowViewOnly(row.item) ? 'flaticon-eye' : 'flaticon2-pen'"
                    ></i
                    > &nbsp; {{ isRowViewOnly(row.item) ? 'Xem' : 'Chỉnh sửa' }} </span
                  > </b-dropdown-item
                > <b-dropdown-item
                  @click="showDeleteAlert(row.item)"
                  v-if="
                    !isRowViewOnly(row.item) &&
                    checkPermission(listPermission, 'STOCK_IMPORT_DELETE')
                  "
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i
                    > &nbsp; Xóa </span
                  > </b-dropdown-item
                > </b-dropdown
              >
            </div>
             </template
          > <template #custom-foot
            > <b-tr class="stock-slip-summary-row"
              > <b-td
                colspan="5"
                class="text-right font-weight-bolder"
                >Tổng theo bộ lọc:</b-td
              > <b-td class="text-right font-weight-bolder"
                > <b-spinner
                  v-if="summaryLoading"
                  small
                  label="Đang tính"
                ></b-spinner
                > <span v-else>{{ convertPrice(summaryQuantity) }}</span
                > </b-td
              > <b-td class="text-right font-weight-bolder"
                > <b-spinner
                  v-if="summaryLoading"
                  small
                  label="Đang tính"
                ></b-spinner
                > <span v-else>{{ formatMoney(summaryAmount) }}</span
                > </b-td
              > <b-td colspan="3"></b-td
              > </b-tr
            > </template
          > </b-table
        > <!-- End of Table session --> <!-- Paginate session --> <b-row
          > <b-col
            >
            <p
              class="mt-3 text-dark"
              style="font-weight: 500"
            >
               Tổng: {{ convertPrice(totalItems) }}
            </p>
             </b-col
          > <b-col
            > <b-pagination-nav
              v-model="page"
              class="custom-pagination"
              v-show="totalPages >= 2"
              :link-gen="linkGen"
              :number-of-pages="totalPages"
              use-router
              @change="fetchStockSlip"
              align="right"
              first-class="page-item-first btn btn-icon btn-sm m-1"
              prev-class="page-item-prev btn btn-icon btn-sm m-1"
              next-class="page-item-next btn btn-icon btn-sm m-1 "
              last-class="page-item-last btn btn-icon btn-sm m-1 "
              page-class="btn btn-icon btn-sm border-0 m-1"
              > <template v-slot:first-text
                > <span> <i class="ki ki-bold-double-arrow-back icon-xs"></i> </span> </template
              > <template v-slot:prev-text> <i class="ki ki-bold-arrow-back icon-xs"></i> </template
              > <template v-slot:next-text> <i class="ki ki-bold-arrow-next icon-xs"></i> </template
              > <template v-slot:last-text
                > <span class="text-info"
                  > <i class="ki ki-bold-double-arrow-next icon-xs"></i> </span
                > </template
              > </b-pagination-nav
            > </b-col
          > </b-row
        > <!-- End of Paginate session --> <AutoStockSlipViewModal
          v-if="isAutoListPage"
          :visible.sync="showAutoStockSlipViewModal"
          :slip-id="selectedViewSlip && selectedViewSlip.id"
          :slip-type="selectedViewSlip && selectedViewSlip.type"
          direction="import"
        /> <template
          > <b-modal
            v-model="showEditPriceModal"
            hide-footer
            :title="'Sửa ghi chú cho phiếu: ' + stockSlipCode"
            > <b-row class="mb-5"
              > <b-col
                > <label
                  class="labelInput"
                  for="inputOriginalPrice"
                  >Ghi chú</label
                > <b-form-textarea
                  v-model="note"
                  placeholder="Nhập ghi chú..."
                  rows="5"
                  max-rows="6"
                ></b-form-textarea
                > </b-col
              > </b-row
            > <b-row
              > <b-col
                > <b-button
                  style="font-weight: 600; width: 70px"
                  variant="primary"
                  size="sm"
                  @click="updateNote"
                  >Lưu</b-button
                > <b-button
                  style="margin-left: 10px; font-weight: 600; width: 70px"
                  variant="secondary"
                  size="sm"
                  @click="handleShowNoteModel"
                  >Hủy</b-button
                > </b-col
              > </b-row
            > </b-modal
          > </template
        > </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import apiCommonMixin from '@/view/mixins/api-common.mixins.js'
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import ApiService from '@/core/services/api.service'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import moment from 'moment'
  import { IMPORT_STOCK } from '@/utils/constants'
  import fileDownload from '@/utils/file-download'
  import { mapGetters } from 'vuex'
  import { VclTable } from 'vue-content-loading'
  import Swal from 'sweetalert2'
  import { checkPermission } from '@/utils/permission'
  import decounce from 'debounce'
  import axios from 'axios'
  import { BASE_URL } from '@/utils/constants'
  import { convertPrice, handleError } from '@/utils/common'
  import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
  import { cloneDeep } from 'lodash'
  import { getToastInstance } from '@/utils/toastHelper'
  import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue'
  import Treeselect from '@riophae/vue-treeselect'
  import { searchCustomers } from '@/utils/customerSearch'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { TIME_TRIGGER } from '@/utils/constants'
  import RowCreatedByDate from '@/view/components/common/RowCreatedByDate.vue'
  import ProviderInfo from '@/view/components/stock-slips/ProviderInfo.vue'
  import AutoStockSlipViewModal from '@/view/components/stock-slips/AutoStockSlipViewModal.vue'
  import {
    AUTO_STOCK_SLIP_LABELS,
    getImportTypeOptionsByListMode,
    getStockSlipListApiPathByMode,
    getStockSlipSummaryApiPathByMode,
    isStockSlipViewOnly,
    sanitizeStockSlipTypeMode,
    STOCK_SLIP_LIST_MODE,
  } from '@/utils/stockSlipOrigin'

  export default {
    mixins: [apiCommonMixin],
    data() {
      return {
        dpForm: {
          startDate: moment().subtract(15, 'days').format('DD/MM/YYYY'),
          endDate: '',
        },
        dpConfigs: {
          start: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
          end: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
        },
        onLoading: false,
        btnCreate: {
          fontWeight: '600!important',
        },
        stockSlips: [],
        searchDescription: '',
        searchStock: '',
        searchPO: '',
        searchVatSerial: '',
        searchVatCode: '',
        vatDateForm: {
          fromDate: '',
          toDate: '',
        },
        searchId: '',
        currentPage: 0,
        totalPages: 1,
        count: 1,
        totalItems: 0,
        summaryQuantity: 0,
        summaryAmount: 0,
        summaryLoading: false,
        page: 1,
        stockSlipType: IMPORT_STOCK,
        fields: [
          {
            key: 'count',
            label: 'STT',
            thStyle: {
              textAlign: 'center',
              fontWeight: 600,
              color: '#181c32',
              width: '4%',
            },
            tdClass: 'sttClass',
          },
          {
            key: 'code',
            label: 'Mã phiếu nhập kho',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '14%' },
            tdClass: 'align-middle',
          },
          {
            key: 'sourceWarehouseId',
            label: 'Kho',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '9%' },
            tdClass: 'align-middle',
          },
          {
            key: 'providerName',
            label: 'Nhà cung cấp',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
            tdClass: 'align-middle',
          },
          {
            key: 'countProduct',
            label: 'SL SP',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%', textAlign: 'right' },
            tdClass: 'text-right align-middle',
          },
          {
            key: 'countQuantity',
            label: 'Tổng SL',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%', textAlign: 'right' },
            tdClass: 'text-right align-middle',
          },
          {
            key: 'totalAmount',
            label: 'Tổng tiền',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '10%', textAlign: 'right' },
            tdClass: 'text-right align-middle',
          },
          {
            key: 'description',
            label: 'Nội dung',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '18%' },
            tdClass: 'align-middle',
          },
          {
            key: 'createBy',
            label: 'Người tạo',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
            tdClass: 'align-middle',
          },
          { key: 'actions', label: '', thStyle: { width: '5%' }, tdClass: 'align-middle' },
        ],
        limit: 10,
        searchProduct: '',
        filteredOptionsProduct: [],
        optionsProduct: [
          {
            data: [],
          },
        ],
        optionsStore: [
          {
            data: [],
          },
        ],
        selectedCompany: null,
        listCompany: [],
        valueStore: [],
        selectedType: 0,
        hoverDescription: false,
        stockSlipCode: '',
        showEditPriceModal: false,
        note: '',
        filterdOptionsStore: [],
        valueProviders: [],
        showAutoStockSlipViewModal: false,
        selectedViewSlip: null,
      }
    },
    computed: {
      ...mapGetters(['listPermission']),
      isAutoListPage() {
        return this.$route.meta.stockSlipListMode === STOCK_SLIP_LIST_MODE.AUTO
      },
      pageTitle() {
        return this.isAutoListPage
          ? AUTO_STOCK_SLIP_LABELS.LIST_IMPORT
          : 'Danh sách phiếu nhập kho'
      },
      listRouteName() {
        return this.isAutoListPage ? 'list-inventory-receipt-auto' : 'list-inventory-receipt'
      },
      viewRouteName() {
        return this.isAutoListPage ? 'view-inventory-receipt-auto' : 'edit-inventory-receipt'
      },
      printRouteName() {
        return this.isAutoListPage ? 'print-receipt-invoice-auto' : 'print-receipt-invoice'
      },
      listType() {
        const listMode = this.isAutoListPage ? STOCK_SLIP_LIST_MODE.AUTO : STOCK_SLIP_LIST_MODE.MANUAL
        return getImportTypeOptionsByListMode(listMode)
      },
    },
    watch: {
      '$route.name'(name, prevName) {
        const listRoutes = ['list-inventory-receipt', 'list-inventory-receipt-auto']
        if (!prevName || name === prevName) return
        if (!listRoutes.includes(name) || !listRoutes.includes(prevName)) return
        this.reloadListForRouteMode()
      },
      listType(options) {
        this.selectedType = sanitizeStockSlipTypeMode(this.selectedType, options)
      },
    },
    methods: {
      convertPrice,
      formatMoney(val) {
        return val != null && val !== '' ? convertPrice(val) : '-'
      },
      formatVatDate(value) {
        if (value == null || value === '') {
          return ''
        }
        const parsed = moment(value, [moment.ISO_8601, 'YYYY-MM-DD', 'DD/MM/YYYY'], true)
        return parsed.isValid() ? parsed.format('DD/MM/YYYY') : String(value)
      },
      checkPermission,
      isStockSlipViewOnly,
      isRowViewOnly(item) {
        return this.isAutoListPage || isStockSlipViewOnly(item)
      },
      ...getToastInstance(),
      updateBreadcrumb() {
        this.$store.dispatch(SET_BREADCRUMB, [
          {
            title: this.isAutoListPage ? AUTO_STOCK_SLIP_LABELS.MENU_PARENT : 'Nhập kho',
            route: this.isAutoListPage ? 'list-inventory-receipt-auto' : 'inventory-receipt',
          },
          { title: this.pageTitle },
        ])
      },
      reloadListForRouteMode() {
        this.page = 1
        this.showAutoStockSlipViewModal = false
        this.selectedViewSlip = null
        this.selectedType = sanitizeStockSlipTypeMode(this.selectedType, this.listType)
        this.restoreFiltersFromQuery()
        this.fetchStockSlip()
        this.fetchSummary()
        this.updateBreadcrumb()
      },
      getListApiPath() {
        const listMode = this.$route.meta.stockSlipListMode || STOCK_SLIP_LIST_MODE.MANUAL
        return getStockSlipListApiPathByMode(listMode)
      },
      getSummaryApiPath() {
        const listMode = this.$route.meta.stockSlipListMode || STOCK_SLIP_LIST_MODE.MANUAL
        return getStockSlipSummaryApiPathByMode(listMode)
      },
      buildFilterParams() {
        let listStoreId = []
        if (this.valueStore.length) {
          listStoreId = this.valueStore.map(({ code }) => code)
        }
        let listProviderId = []
        if (this.valueProviders.length) {
          listProviderId = this.valueProviders.map((p) => p.id)
        }
        return {
          searchDescription: this.searchDescription,
          searchCode: this.searchId,
          searchPO: this.searchPO,
          searchVatSerial: this.searchVatSerial,
          searchVatCode: this.searchVatCode,
          searchVatDateFrom: this.vatDateForm.fromDate
            ? moment(this.vatDateForm.fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
            : '',
          searchVatDateTo: this.vatDateForm.toDate
            ? moment(this.vatDateForm.toDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
            : '',
          fromDate: this.dpForm.startDate
            ? moment(this.dpForm.startDate, 'DD/MM/YYYY').format('yyyy-MM-DD 00:00:00')
            : '',
          toDate: this.dpForm.endDate
            ? moment(this.dpForm.endDate, 'DD/MM/YYYY').format('yyyy-MM-DD 23:59:59')
            : '',
          type: this.stockSlipType,
          searchProduct: this.searchProduct,
          storeIds: listStoreId,
          companyId: this.selectedCompany,
          mode: this.selectedType,
          providerIds: listProviderId,
        }
      },
      // Tổng theo bộ lọc: gọi riêng, chỉ khi đổi bộ lọc (không gọi lại khi phân trang)
      fetchSummary: async function () {
        this.summaryLoading = true
        try {
          const params = this.buildFilterParams()
          const response = await ApiService.query(this.getSummaryApiPath(), { params })
          const summary = response.data.data || {}
          this.summaryQuantity = summary.totalQuantity || 0
          this.summaryAmount = summary.totalAmount || 0
        } catch (err) {
          // Lỗi (vd: vượt giới hạn ngày) đã được hiển thị ở danh sách, ở đây chỉ reset tổng
          this.summaryQuantity = 0
          this.summaryAmount = 0
        } finally {
          this.summaryLoading = false
        }
      },
      fetchStockSlip: async function () {
        this.onLoading = true
        this.page = this.$route.query.page
        if (!this.page) {
          this.page = 1
        }

        const params = {
          page: this.page,
          limit: 10,
          ...this.buildFilterParams(),
        }

        ApiService.query(this.getListApiPath(), { params })
          .then((response) => {
            this.stockSlips = []
            const stockResponse = response.data.data.data
            this.totalPages = response.data.data.totalPage
            this.currentPage = response.data.data.currentPage
            this.totalItems = response.data.data.totalRow
            let result = []
            stockResponse.forEach((item, index) => {
              const stock = {
                ...item,
                count: this.currentPage >= 2 ? index + 1 + this.currentPage * 10 - 10 : index + 1,
                createdAt: moment(item.createdAt).format('HH:mm:ss DD/MM/YYYY'),
              }
              result.push(stock)
              this.stockSlips = [...new Set(result)]
            })
            this.onLoading = false
          })
          .catch((err) => {
            this.onLoading = false
            handleError(err)
          })
      },
      openStockSlipItem: function (item) {
        const isView = this.isRowViewOnly(item)
        if (isView && this.isAutoListPage) {
          this.selectedViewSlip = item
          this.showAutoStockSlipViewModal = true
          return
        }
        this.$router.push({
          name: isView ? this.viewRouteName : 'edit-inventory-receipt',
          query: {
            id: item.id,
            ...(isView ? { viewOnly: '1' } : {}),
          },
        })
      },
      showDeleteAlert: function (item) {
        Swal.fire({
          title: 'Xóa phiếu nhập kho!',
          text: 'Bạn có chắc muốn xóa phiếu nhập kho này không ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(221, 51, 51)',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: 'Xóa',
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          reverseButtons: true,
          position: 'top',
        }).then((result) => {
          if (result.value) {
            this.deleteItem(item)
          }
        })
      },
      deleteItem: async function (item) {
        ApiService.delete(`v1/stock-slips/${item.id}`).then(({ data }) => {
          this.makeToastSuccess(data.message)
          this.fetchStockSlip()
          this.fetchSummary()
        })
      },
      fetchProduct() {
        this.optionsProduct[0].data = []
        ApiService.get(`products/searchProductByName?name=${this.searchProduct}`).then(
          ({ data }) => {
            const products = data.data
            products.map((element) => {
              this.optionsProduct[0].data.push(element)
            })
            this.filteredOptionsProduct = [...this.optionsProduct[0].data]
          },
        )
      },
      debounceInput: decounce(function () {
        this.fetchProduct()
      }, 500),
      onSelectedProduct(option) {
        this.searchProduct = option.item.productName
      },
      onInputChangeProduct(text) {
        if (!text) {
          text = ''
        }
        this.searchProduct = text
        this.debounceInput()
      },
      linkGen(pageNum) {
        const q = { ...this.$route.query }
        if (pageNum === 1) delete q.page
        else q.page = pageNum
        const s = Object.entries(q)
          .filter(([, v]) => v !== undefined && v !== null && v !== '')
          .map(([k, v]) =>
            Array.isArray(v)
              ? v.map((vv) => `${k}=${encodeURIComponent(vv)}`).join('&')
              : `${k}=${encodeURIComponent(v)}`,
          )
          .join('&')
        return s ? `?${s}` : '?'
      },
      buildQueryFromState() {
        const query = { page: 1 }
        if (this.dpForm.startDate) query.startDate = this.dpForm.startDate
        if (this.dpForm.endDate) query.endDate = this.dpForm.endDate
        if (this.searchId && this.searchId.trim()) query.searchId = this.searchId.trim()
        if (this.searchDescription && this.searchDescription.trim())
          query.searchDescription = this.searchDescription.trim()
        if (this.searchPO && this.searchPO.trim()) query.searchPO = this.searchPO.trim()
        if (this.searchVatSerial && this.searchVatSerial.trim())
          query.searchVatSerial = this.searchVatSerial.trim()
        if (this.searchVatCode && this.searchVatCode.trim())
          query.searchVatCode = this.searchVatCode.trim()
        if (this.vatDateForm.fromDate) query.searchVatDateFrom = this.vatDateForm.fromDate
        if (this.vatDateForm.toDate) query.searchVatDateTo = this.vatDateForm.toDate
        if (this.valueStore && this.valueStore.length)
          query.storeIds = this.valueStore.map(({ code }) => code)
        if (this.searchProduct && this.searchProduct.trim())
          query.searchProduct = this.searchProduct.trim()
        if (this.selectedCompany != null && this.selectedCompany !== '')
          query.companyId = this.selectedCompany
        if (this.valueProviders && this.valueProviders.length)
          query.providerIds = this.valueProviders.map((p) => p.id)
        if (this.selectedType != null && this.selectedType !== '' && Number(this.selectedType) !== 0) {
          query.mode = this.selectedType
        }
        return query
      },
      restoreFiltersFromQuery() {
        const query = this.$route.query
        if (query.startDate) this.dpForm.startDate = query.startDate
        if (query.endDate) this.dpForm.endDate = query.endDate
        if (query.searchId) this.searchId = query.searchId
        if (query.searchDescription) this.searchDescription = query.searchDescription
        if (query.searchPO) this.searchPO = query.searchPO
        if (query.searchVatSerial) this.searchVatSerial = query.searchVatSerial
        if (query.searchVatCode) this.searchVatCode = query.searchVatCode
        if (query.searchVatDateFrom) this.vatDateForm.fromDate = query.searchVatDateFrom
        if (query.searchVatDateTo) this.vatDateForm.toDate = query.searchVatDateTo
        if (query.searchProduct) this.searchProduct = query.searchProduct
        if (query.companyId !== undefined && query.companyId !== null && query.companyId !== '') {
          this.selectedCompany = Number(query.companyId)
        }
        if (query.mode !== undefined && query.mode !== null && query.mode !== '') {
          this.selectedType = sanitizeStockSlipTypeMode(query.mode, this.listType)
        }
        const storeIds = query.storeIds
        if (storeIds && this.filterdOptionsStore.length) {
          const ids = Array.isArray(storeIds) ? storeIds : [storeIds]
          this.valueStore = ids
            .map((code) => {
              const opt = this.filterdOptionsStore.find((s) => String(s.code) === String(code))
              return opt ? { code: opt.code, name: opt.name, checked: true } : null
            })
            .filter(Boolean)
        }
        const providerIds = query.providerIds
        if (providerIds) {
          const ids = Array.isArray(providerIds) ? providerIds : [providerIds]
          this.valueProviders = ids.map((id) => ({ id: Number(id), label: String(id) }))
        }
      },
      onFilter() {
        const query = this.buildQueryFromState()
        this.$router.push({ name: this.listRouteName, query })
        this.fetchStockSlip()
        this.fetchSummary()
      },
      clearFilters() {
        this.dpForm.startDate = moment().subtract(15, 'days').format('DD/MM/YYYY')
        this.dpForm.endDate = ''
        this.searchId = ''
        this.searchDescription = ''
        this.searchPO = ''
        this.searchVatSerial = ''
        this.searchVatCode = ''
        this.vatDateForm.fromDate = ''
        this.vatDateForm.toDate = ''
        this.valueStore = []
        this.searchProduct = ''
        this.selectedCompany = null
        this.valueProviders = []
        this.selectedType = 0
        this.$router.push({ name: this.listRouteName, query: { page: 1 } })
        this.fetchStockSlip()
        this.fetchSummary()
      },
      fetchCompany: async function () {
        this.listCompany = []
        const response = await ApiService.get('/v1/companies/all')
        this.listCompany = response.data.data
        this.listCompany.unshift({
          id: null,
          name: 'Tất cả',
        })
      },
      onChangeCompany() {
        this.valueStore = []
        this.searchStock = ''
      },
      getLinkDoc(item) {
        return `#/inventory-receipt/edit-inventory-receipt?id=${item.id}`
      },
      reportClick: async function () {
        let listId = []
        if (this.valueStore.length) {
          listId = this.valueStore.map(({ code }) => code)
        }
        let listProviderId = []
        if (this.valueProviders.length) {
          listProviderId = this.valueProviders.map((p) => p.id)
        }
        const searchDescription = this.searchDescription?.trim() || ''
        const searchCode = this.searchId?.trim() || ''
        const searchPO = this.searchPO?.trim() || ''
        const searchVatSerial = this.searchVatSerial?.trim() || ''
        const searchVatCode = this.searchVatCode?.trim() || ''
        const searchVatDateFrom = this.vatDateForm.fromDate
          ? moment(this.vatDateForm.fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : ''
        const searchVatDateTo = this.vatDateForm.toDate
          ? moment(this.vatDateForm.toDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : ''
        const searchFromDay = this.dpForm.startDate
          ? moment(this.dpForm.startDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : ''
        const searchToDay = this.dpForm.endDate
          ? moment(this.dpForm.endDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : ''
        const searchProduct = this.searchProduct
        const companyId = this.selectedCompany
        const typeSearch = this.selectedType
        const baseUrl = BASE_URL

        const exportQuery = [
          `type=${this.stockSlipType}`,
          `providerId=${this.selectedProvider}`,
          `searchProduct=${searchProduct}`,
          `searchDescription=${searchDescription}`,
          `searchCode=${searchCode}`,
          `searchPO=${searchPO}`,
          `searchVatSerial=${searchVatSerial}`,
          `searchVatCode=${searchVatCode}`,
          `searchVatDateFrom=${searchVatDateFrom}`,
          `searchVatDateTo=${searchVatDateTo}`,
          `searchFromDay=${searchFromDay}`,
          `searchToDay=${searchToDay}`,
          `companyId=${companyId}`,
          `typeSearch=${typeSearch}`,
          ...listId.map((n, index) => `storeIds[${index}]=${n}`),
          ...listProviderId.map((n, index) => `providerIds[${index}]=${n}`),
        ]
        const url = `${baseUrl}v1/stock-slips/export-excel-stock-slip?${exportQuery.join('&')}`
        await axios({
          url: url,
          method: 'GET',
          responseType: 'blob',
          onDownloadProgress: function (progressEvent) {
            console.log(progressEvent)
          },
        })
          .then((response) => {
            const fileName = fileDownload.getFileName(response)
            fileDownload.createFile(response.data, fileName)
          })
          .catch(async (err) => {
            // responseType: 'blob' nên phải đọc Blob → text → JSON để lấy message thật
            try {
              const text = await err.response?.data?.text()
              const json = JSON.parse(text)
              err.response.data = json
            } catch (_) {
              // giữ nguyên err nếu parse thất bại
            }
            handleError(err)
          })
      },
      handleShowNoteModel(item) {
        this.showEditPriceModal = !this.showEditPriceModal
        this.stockSlipCode = item.code
        this.note = item.description
      },
      updateNote() {
        const data = {
          stockSlipCode: this.stockSlipCode,
          description: this.note,
        }
        ApiService.put('v1/stock-slips/note', data)
          .then(({ data }) => {
            this.makeToastSuccess(data.message)
            this.showEditPriceModal = !this.showEditPriceModal
            this.fetchStockSlip()
          })
          .catch(({ response }) => {
            this.makeToastFaile(response.$error)
          })
      },
      loadProviderOptions({ action, searchQuery, callback }) {
        if (action === 'ASYNC_SEARCH') {
          this.debounceLoadProviders(searchQuery, callback)
        }
      },
      getProviderCode(item) {
        return item.providerCode || ''
      },
      getProviderTaxCode(item) {
        if (item.providerTaxCode) return item.providerTaxCode
        if (item.taxCode) return item.taxCode
        return ''
      },
      printItem: function (item) {
        this.$router.push({
          name: this.printRouteName,
          query: { id: item.id },
        })
      },
      printProductQRCode: function (stockSlipId) {
        this.$router.push({
          name: 'print-imei-barcode',
          query: { stockSlipId: stockSlipId },
        })
      },
      exportDanhSachImeiExcel(item) {
        ApiService.get(`v1/stock-slips/${item.id}/export-imei-excel`, {
          responseType: 'blob',
        })
          .then((response) => {
            const fileName =
              fileDownload.getFileName(response) || `danh-sach-imei-${item.code}.xlsx`
            fileDownload.createFile(response.data, fileName)
            this.makeToastSuccess('Tải file Excel danh sách IMEI thành công!')
          })
          .catch(async (err) => {
            try {
              const text = await err.response?.data?.text()
              const json = JSON.parse(text)
              err.response.data = json
            } catch (_) {}
            handleError(err)
          })
      },
    },
    mounted() {
      this.updateBreadcrumb()
    },
    async created() {
      const { stores, currentStoreId, currentStoreName } = await this.fetchStoreByUser()
      this.optionsStore = []
      stores.map((element) => {
        const option = {
          code: element.id,
          name: element.name,
          shortName: element.shortName,
          checked: false,
        }
        this.optionsStore.push(option)
      })
      this.filterdOptionsStore = cloneDeep(this.optionsStore)
      if (currentStoreId) {
        this.valueStore = [
          {
            code: currentStoreId,
            name: currentStoreName,
            checked: true,
          },
        ]
      }
      await this.fetchCompany()
      this.debounceLoadProviders = decounce(async (searchQuery, callback) => {
        try {
          const items = await searchCustomers(searchQuery)
          callback(null, items.map((c) => ({ id: c.id, label: c.fullName })))
        } catch (err) { callback(err) }
      }, TIME_TRIGGER)
      this.restoreFiltersFromQuery()
      this.fetchStockSlip()
      this.fetchSummary()
    },
    components: {
      KTCodePreview,
      Autosuggest,
      VclTable,
      BDropdownCustom,
      Treeselect,
      RowCreatedByDate,
      ProviderInfo,
      AutoStockSlipViewModal,
    },
  }
</script>

<style lang="scss">
  .stock-slips {
  .table th,
  .table td {
    padding: 0.25rem;
    vertical-align: middle;
    border-top: 1px solid #ecf0f3;
  }

  code,
  pre {
    margin: 1em 0;
    padding: 1em;
    border: 1px solid #bbb;
    display: block;
    background: #ddd;
    border-radius: 3px;
  }

  .form-group {
    margin-bottom: 1em;
  }

  .btn.btn-icon.btn-sm,
  .btn-group-sm > .btn.btn-icon {
    height: calc(1.35em + 1.1rem + 2px);
    width: auto;
  }
  .icon:hover {
    background-color: #90c6fc;
  }

  .sttClass {
    width: 20px;
  }

  ::-webkit-datetime-edit-year-field:not([aria-valuenow]),
  ::-webkit-datetime-edit-month-field:not([aria-valuenow]),
  ::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
    color: transparent;
  }

  .productCode:hover {
    text-decoration: underline;
  }

  .inventory-receipt-code {
    display: flex;
    flex-direction: column;
    gap: 4px;
    line-height: 1.4;

    .code-link {
      color: #000;
      text-decoration: none;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        color: #007bff;
        text-decoration: underline;
      }
    }

    .po-code {
      margin-top: 2px;
      line-height: 1.3;

      .po-label {
        font-size: 12px;
        color: #000;
      }

      .po-value {
        font-size: 12px;
        color: #5d9cec;
        margin-left: 4px;
      }
    }

    .vat-serial {
      margin-top: 2px;
      line-height: 1.3;

      .vat-label {
        font-size: 10px;
        color: #000;
      }

      .vat-value {
        font-size: 10px;
        color: #f6a623;
        margin-left: 4px;
      }
    }
  }

  .inventory-receipt-description {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    max-height: 4.5em;
    line-height: 1.4;
    font-size: 0.875rem;

    &__text {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    &__icon {
      flex-shrink: 0;
      min-width: 1.5rem;
      cursor: pointer;
      color: #6c757d;
      padding: 0.15rem;
      text-align: right;

      &:hover {
        color: #007bff;
      }

      i {
        font-size: 0.8rem;
      }
    }
  }

  .inventory-receipt-table {
    thead th {
      font-weight: 600;
      font-size: 0.8rem;
      padding: 0.5rem 0.4rem;
      background-color: #f8f9fa;
    }
    tbody td {
      font-size: 0.875rem;
      padding: 0.5rem 0.4rem;
    }
  }

  .stock-slip-summary-row td {
    background-color: #f1f5f9;
    border-top: 2px solid #d0d7de;
    color: #181c32;
  }

  .togge-filter {
    background-color: #3d8cdd;
    border-color: #3d8cdd;
  }

  .toggle-filter-icon {
    display: inline-block;
    transition: transform 0.2s ease;
  }

  .togge-filter[aria-expanded='true'] .toggle-filter-icon {
    transform: rotate(180deg);
  }

  .checkbox-label {
    display: block;
  }
  .page-item.disabled {
    cursor: not-allowed;
    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }
}
</style>

